import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
var _excluded = ["keyboardFocused"];
import React from 'react';
import cn from 'classnames';
import { createBaseComponent, sstyled } from 'intergalactic/core';
import { useBox } from 'intergalactic/flex-box';
import keyboardFocusEnhance from 'intergalactic/utils/lib/enhances/keyboardFocusEnhance';
import propsForElement from 'intergalactic/utils/lib/propsForElement';
import logger from 'intergalactic/utils/lib/logger';
import { useForkRef } from 'intergalactic/utils/lib/ref';
import hasLabels from 'intergalactic/utils/lib/hasLabels';
import { useColorResolver } from 'intergalactic/utils/lib/use/useColorResolver';
/*__reshadow-styles__:"./style/icon.shadow.css"*/
var styles = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SIcon_8ak07_gg_{display:inline-block;-webkit-user-select:none;-moz-user-select:none;user-select:none;shape-rendering:geometricPrecision;box-sizing:content-box;fill:currentColor;flex-shrink:0;outline:0;color:var(--color_8ak07)}.___SIcon_8ak07_gg_.__keyboardFocused_8ak07_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SIcon_8ak07_gg_.__interactive_8ak07_gg_{cursor:pointer}@media (hover:hover){.___SIcon_8ak07_gg_.__interactive_8ak07_gg_:hover{filter:brightness(.8)}}.___SIcon_8ak07_gg_.__noPointerEvents_8ak07_gg_{pointer-events:none}" /*__inner_css_end__*/, "8ak07_gg_") /*__reshadow_css_end__*/, {
  "__SIcon": "___SIcon_8ak07_gg_",
  "--color": "--color_8ak07",
  "_keyboardFocused": "__keyboardFocused_8ak07_gg_",
  "_noPointerEvents": "__noPointerEvents_8ak07_gg_",
  "_interactive": "__interactive_8ak07_gg_"
});
function Icon(props, ref) {
  var _useBox = useBox(_objectSpread({
      tag: 'svg',
      'data-ui-name': 'Icon',
      width: 16,
      height: 16,
      viewBox: '0 0 16 16',
      focusable: props.interactive
    }, props), ref),
    _useBox2 = _slicedToArray(_useBox, 2),
    SIcon = _useBox2[0],
    other = _useBox2[1];
  var interactive = props.interactive,
    colorProps = props.color;
  var resolveColor = useColorResolver();
  var color = resolveColor(colorProps);
  var _keyboardFocusEnhance = keyboardFocusEnhance()(_objectSpread({
      disabled: !interactive
    }, other)),
    keyboardFocused = _keyboardFocusEnhance.keyboardFocused,
    propsEnhance = _objectWithoutProperties(_keyboardFocusEnhance, _excluded);
  var sstyles = sstyled(styles);
  var _sstyles$cn = sstyles.cn('SIcon', {
      'use:color': color,
      interactive: interactive,
      keyboardFocused: keyboardFocused,
      noPointerEvents: !interactive
    }),
    className = _sstyles$cn.className,
    style = _sstyles$cn.style;
  function onKeyDown(event) {
    if (propsEnhance.onKeyDown) {
      return propsEnhance.onKeyDown(event);
    }
    if (interactive && propsEnhance.onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      propsEnhance.onClick(event);
    }
  }
  var labelCheckRef = React.useRef();
  React.useEffect(function () {
    if (!interactive) return;
    if (process.env.NODE_ENV !== 'production') {
      logger.warn(labelCheckRef.current && !hasLabels(labelCheckRef.current), "'aria-label' or 'aria-labelledby' are required props for interactive icons", props['data-ui-name'] || Icon.displayName);
    }
  }, [interactive]);
  var forkedRef = useForkRef(ref, labelCheckRef);
  return /*#__PURE__*/React.createElement(SIcon, _extends({
    role: interactive ? 'button' : undefined,
    "aria-hidden": interactive ? undefined : 'true'
  }, propsForElement(propsEnhance), {
    style: Object.assign({}, style, propsEnhance.style),
    className: cn(className, propsEnhance.className) || undefined,
    onKeyDown: onKeyDown,
    ref: forkedRef
  }));
}
Icon.displayName = 'Icon';
export default createBaseComponent(Icon);
//# sourceMappingURL=Icon.js.map